import { useFormContext } from 'react-hook-form';
import { ApplicationFormInputRenderer } from '../ApplicationFormInputRenderer';

import { IApplicationFormStep } from 'features/ApplicationForm/types';

interface IApplicationFromSectionsProps {
  step: IApplicationFormStep;
  currentStep: number;
}

const ApplicationFormSections = (props: IApplicationFromSectionsProps) => {
  const { step, currentStep } = props;
  const { sections = [], component: Component } = step;
  const { watch } = useFormContext();
  const values = watch();

  if (Component) {
    return <Component />;
  }
  return (
    <>
      {sections.map((section) => (
        <ApplicationFormInputRenderer
          key={section.id}
          section={section}
          formValues={values}
          currentStep={currentStep}
        />
      ))}
    </>
  );
};

export default ApplicationFormSections;
